export default {
  uploadImage: null,
  imageData: null,
  imageDataLoading: false,
};
